import { Typography } from "get-life-storybook-ts";
import TrustpilotCommentBox, {
  TrustPilotSVG,
} from "get-life-storybook-ts/lib/molecules/TrustpilotCommentBox/TrustpilotCommentBox";
import "./TrustpilotReviews.scss";

interface TrustpilotComment {
  commentText: string;
  commentUser: string;
}

interface TrustpilotReviewsProps {
  title: string;
  excelentText: string;
  trustpilotText: string;
  rating: number;
  comments: TrustpilotComment[];
}

const TrustpilotReviews = ({
  title,
  excelentText,
  trustpilotText,
  rating,
  comments,
}: TrustpilotReviewsProps) => {
  if (!comments || comments.length === 0) return null;

  // Duplicate the list so the marquee can loop seamlessly (translateX -50%).
  const loop = [...comments, ...comments];

  return (
    <div className="trustpilotSection bg-green-truspilot flex justify-center content-center flex-col p-[40px] md:p-[50px] w-full">
      <Typography
        text={title}
        className="max-w-[700px] text-center my-0 mx-auto pb-[25px]"
        weight="700"
        variant="H2"
        color="purple"
      />
      <div className="flex justify-center items-center flex-row flex-wrap pb-[10px]">
        <Typography variant="Body" text={excelentText} weight="700" />
        <Typography className="px-4" variant="BodyMedium" text="|" />
        <Typography
          className="pr-2"
          variant="Body"
          text={`${rating}`}
          weight="700"
        />
        <Typography variant="Body" text={trustpilotText} />
      </div>
      <div className="flex justify-center pb-[20px]">
        <TrustPilotSVG />
      </div>
      <div className="tp-marquee max-w-[1165px] w-full my-0 mx-auto overflow-hidden">
        <div
          className="tp-marquee__track"
          style={{ animationDuration: `${loop.length * 4}s` }}
        >
          {loop.map((comment, index) => (
            <div className="tp-marquee__item" key={index}>
              <TrustpilotCommentBox
                commentText={comment.commentText}
                commentUser={comment.commentUser}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustpilotReviews;
